import { Component, EventEmitter, Input, Output } from "@angular/core";
 import { TranslateModule } from "@ngx-translate/core";
import { ModalOneComponent } from "../../shared/design-system/modal-one/modal-one.component";
import { ButtonComponent } from "../../shared/design-system/button/button.component";
import { ButtonConfig } from "../../shared/design-system/button/button.modal";
import { TranslateService } from "@ngx-translate/core";
import { ModalOneConfig } from "../../shared/design-system/modal-one/modal-one.modal";


@Component({
    selector: "founder-message",
    templateUrl: "founder-message.component.html",
    standalone: true,
    imports: [TranslateModule, ModalOneComponent, ButtonComponent]
})
export class FounderMessageComponent {
    constructor(private translate: TranslateService) {}
    modalOneConfig!: ModalOneConfig;
    showSuccess: boolean = false;
    @Input() loginUserName: string = '';
    @Input() modalDescription: string = '';
    @Input() set isVisible(value: boolean) {
        this.showSuccess = value;
        if (this.modalOneConfig) {
            this.modalOneConfig.visible = value;
        }
    }
    @Output() closeEvent = new EventEmitter<void>();
    buttonConfig!: ButtonConfig;

    ngOnInit() {
        this.buttonConfig = {
        id: 'get-started-button',
        label: this.translate.instant('get_started'),
        color: "primary", 
        size: "lg",
        ariaLabel: "get_started"
        };
        this.modalOneConfig = {
            visible:this.showSuccess,
            modalTitle: this.translate.instant('welcome_message'),
            modalTitleDescription: this.translate.instant('founder_message'),
            founderImage:"assets/images/onboarding/founder.png",
            size: 'lg'
        };
    }

    onClick() {
        this.closeEvent.emit();
    }
}

